import React, { FC } from 'react'
import { createUseStyles } from 'react-jss'
import { Note as NoteIcon, Plus } from '../../../assets/icons'
import { Note } from '../../../models/Note'
import { colors } from '../../../theme/palette'
import { baseButton } from '../../../theme/reuseables'
import { L } from '../../providers/Lokalise'
import { Circle } from '../../ui/Card'
import { CircleIcon } from '../../ui/Circle/Circle'

interface EditMemberNoteButtonProps {
    onClickCreate?: () => void
    onClickView?: () => void
    notes: Note[]
    withBorder?: boolean
    firstNoteLabel?: string
}

const useStyles = createUseStyles({
    wrapper: {
        display: 'flex',
    },
    button: {
        ...baseButton,
        ...{
            backgroundColor: colors.white,
            height: '56px',
            fontSize: '18px',
            padding: '16px',
            borderRadius: '0.5rem',
            cursor: 'pointer',
            textAlign: 'left',
            justifyContent: 'start',
        },
    },
    withBorder: {
        border: `1px solid ${colors.borderColor}`,
    },
})

const EditMemberNoteButton: FC<EditMemberNoteButtonProps> = ({
    onClickCreate,
    onClickView,
    notes,
    withBorder,
    firstNoteLabel,
}) => {
    const classes = useStyles()

    if (notes.length > 0) {
        return (
            <div className={classes.wrapper}>
                <button
                    className={classes.button}
                    style={{ flexGrow: 1 }}
                    type="button"
                    onClick={onClickView}
                >
                    <Circle>
                        <CircleIcon>
                            <NoteIcon />
                        </CircleIcon>
                    </Circle>
                    <span>Noter</span>
                    <span style={{ marginLeft: 'auto' }}>{notes.length}</span>
                </button>
                <button
                    className={classes.button}
                    style={{
                        width: '48px',
                        padding: 0,
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                    type="button"
                    onClick={onClickCreate}
                >
                    <Plus width="20px" />
                </button>
            </div>
        )
    }

    return (
        <button
            className={`${classes.button} ${
                withBorder ? classes.withBorder : ''
            }`}
            style={{ width: '100%' }}
            type="button"
            onClick={onClickCreate}
        >
            <Circle>
                <CircleIcon>
                    <NoteIcon />
                </CircleIcon>
            </Circle>
            <span>{firstNoteLabel}</span>
            <span
                style={{ marginLeft: 'auto', position: 'relative', top: '3px' }}
            >
                <Plus width="30px" color={colors.green500} />
            </span>
        </button>
    )
}

EditMemberNoteButton.defaultProps = {
    firstNoteLabel: L('PROFIL_NOTER_FORM_FØRSTE-NOTE_KNAP'),
}

export { EditMemberNoteButton }
